import { ArnErc721ConditionService } from './ArnErc721ConditionService';
import { ArnConditionService } from '../ArnConditionService';
import { ArnConditionsPayload, HasERC721Condition } from '@arianee/arn-types';
import { ArnDelegateConditionService } from '../ArnDelegateConditionService';

export class DefaultErc721ConditionService
  extends ArnDelegateConditionService
  implements ArnErc721ConditionService
{
  constructor(condition: ArnConditionService) {
    super(condition);
  }

  static readonly CONDITION_OWNS = 'own';

  async isOwnedFrom(
    contractAddress: string,
    minBalance = 1, // Owns at least one by default
    chainId = 1 // Etherum by default
  ): Promise<boolean> {
    return await this.isOwned(
      DefaultErc721ConditionService.CONDITION_OWNS,
      chainId,
      contractAddress,
      minBalance
    );
  }

  async isOwnedByName(name: string): Promise<boolean> {
    return await this.isOwned(name);
  }

  async isOwned(
    name: string,
    chainId?: number,
    contractAddress?: string,
    minBalance?: number
  ) {
    const erc721Condition = new HasERC721Condition({
      name,
      chainId,
      contractAddress,
      minBalance,
    });
    const conditionsPayload: ArnConditionsPayload = {
      and: [erc721Condition],
    };
    const result = await this.condition.execute(conditionsPayload);
    return result.success;
  }
}
